const initialState = { transactionsData: [], dashboardData: [], registerTransactionData: [] };

export const TRANSACTIONREDUCER = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_TRANSACTIONS':
            return {
                ...state,
                transactionsData: action.data
            }
        case 'GET_DASHBOARD_DATA':
            return {
                ...state,
                dashboardData: action.data
            }
        case 'GET_REGISTER_TRANSACTIONS':
            return {
                ...state,
                registerTransactionData: action.data
            }
        default:
            return state;
    }
}